/**
 * Platform-level types shared between API and web.
 */

import { z } from "zod";

export const PlatformStatsSchema = z.object({
	tokensLaunched: z.number(),
	totalVolume: z.string(),
	activeWallets: z.number(),
	dataSource: z.enum(["d1", "cache", "seeded"]),
	dataAge: z.number(),
});

export type PlatformStats = z.infer<typeof PlatformStatsSchema>;
